var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
import { NOT_LOADED } from "../Infra/RemoteData";
import { PatientConsentViewModel } from "./PatientConsentViewModel";
export class PatientConsentInterventionalEnrollmentTimelineForVisitsViewModel extends PatientConsentViewModel {
    get timelineVisits() {
        var _a;
        if (this.study === NOT_LOADED || this.study === null)
            return [];
        const currentLanguage = this.patientConsentUIManager.currentLanguage;
        const currentLanguageFields = this.study.studyTranslatableFields.find((fields) => fields.language === currentLanguage);
        return (_a = currentLanguageFields === null || currentLanguageFields === void 0 ? void 0 : currentLanguageFields.timelineVisits) !== null && _a !== void 0 ? _a : this.study.timelineVisits;
    }
}
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentInterventionalEnrollmentTimelineForVisitsViewModel.prototype, "timelineVisits", null);
